<script lang="ts" setup>
import { MailRequest } from '@/objects/generated';
import { InputText } from '@/components';

const value = defineModel<MailRequest>({ required: true });
</script>
<template>
    <form class="row g-3">
        <div class="col-md-6">
            <InputText
                placeholder="general.placeholderemail"
                label="general.email"
                label-position="top"
                v-model="value.Sender"
            />
        </div>
        <div class="col-md-6">
            <InputText
                placeholder="general.placeholdername"
                label="general.name"
                label-position="top"
                v-model="value.SenderName"
            />
        </div>
        <div class="col-12">
            <InputText
                placeholder="communication.errorreportmessageplaceholder"
                label="communication.errorreportmessage"
                label-position="top"
                v-model="value.Message"
                :multiline="true"
            />
        </div>
    </form>
</template>
